module.exports = __webpack_public_path__ + "img/garden64_ua.9ff4992a.webp";